var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1904 8.13386C20.6703 8.7788 20.6703 9.64947 20.1904 10.2934C18.6788 12.3208 15.052 16.4952 10.8178 16.4952C6.58359 16.4952 2.95685 12.3208 1.44521 10.2934C1.21171 9.98456 1.08496 9.60466 1.08496 9.21361C1.08496 8.82257 1.21171 8.44267 1.44521 8.13386C2.95685 6.10645 6.58359 1.93201 10.8178 1.93201C15.052 1.93201 18.6788 6.10645 20.1904 8.13386V8.13386Z",
    stroke: "#6B9DFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8177 12.3343C12.4953 12.3343 13.8552 10.9371 13.8552 9.21358C13.8552 7.49008 12.4953 6.0929 10.8177 6.0929C9.1402 6.0929 7.78027 7.49008 7.78027 9.21358C7.78027 10.9371 9.1402 12.3343 10.8177 12.3343Z",
    stroke: "#6B9DFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.c7295c1a6628638fb6424281b402fa00.svg";
export { ForwardRef as ReactComponent };